import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import _ from 'lodash-es';
import { CharacterType, ComponentType } from '../../_study_constants';
import { KeywordFilterService } from '@services/keyword-filter.service';

@Directive({
  selector: '[appKeywordsBooleanLogic]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: KeywordsBooleanLogicValidator,
      multi: true,
    },
  ],
})
export class KeywordsBooleanLogicValidator implements Validator {
  constructor(private keywordFilterService: KeywordFilterService) {}

  validate(control: AbstractControl): ValidationErrors | null {
    const booleanLogic = control.value;
    const valid = this.isBooleanLogicValid(booleanLogic);

    return valid ? null : { booleanLogic: { valid: false } };
  }

  isBooleanLogicValid(booleanLogic: string): boolean {
    const bracketsQueue: string[] = [];
    let prevComponentType: ComponentType = null;
    let prevConnector: string = null;

    if (this.keywordFilterService.findEnterRegex.test(booleanLogic)) {
      return false;
    }

    let input: string = _.toLower(_.trim(booleanLogic));

    if (input === '*' || input === '"*"') {
      return true;
    }

    while (input.length > 0) {
      const character = input.slice(0, 1);
      input = input.substr(1);

      const charType = this.keywordFilterService.determineCharacterType(character);

      if (charType === CharacterType.OpeningBracket) {
        if (!this.keywordFilterService.processOpeningBracket(bracketsQueue, prevComponentType)) {
          return false;
        }

        prevComponentType = ComponentType.OpeningBracket;
      } else if (charType === CharacterType.ClosingBracket) {
        if (!this.keywordFilterService.processClosingBracket(bracketsQueue, prevComponentType)) {
          return false;
        }

        prevComponentType = ComponentType.ClosingBracket;
      } else if (charType === CharacterType.Quote) {
        if (prevComponentType !== null && this.keywordFilterService.notAllowedComponentsBeforePhrase.includes(prevComponentType)) {
          return false;
        }

        const phrase = this.keywordFilterService.getPhrase(input);

        if (!this.keywordFilterService.isValidPhrase(phrase, input.length)) {
          return false;
        }

        input = input.substr(phrase.length + 1);
        prevComponentType = ComponentType.Phrase;
      } else if (charType === CharacterType.Character) {
        const text = character + this.keywordFilterService.getWord(input);
        const isConnector = this.keywordFilterService.allowedConnectors.includes(text) ? true : false;

        if (isConnector) {
          if (!this.keywordFilterService.processConnector(text, prevConnector, prevComponentType)) {
            return false;
          }
          prevConnector = text;
        } else {
          if (!this.keywordFilterService.processWord(text, prevComponentType)) {
            return false;
          }
        }

        prevComponentType = isConnector ? ComponentType.Connector : ComponentType.Word;
        input = input.substr(text.length - 1); // - 1 because the first char was already consumed
      }
    }

    if (prevComponentType === ComponentType.Connector || bracketsQueue.length > 0) {
      return false;
    }

    return true;
  }
}
